//imports

import {Box} from "@mui/material";

const CountryFlag = ({ src }) => {
  return (
    <Box
      component='img'
      src={src}
      sx={{
      position: 'absolute',
      top:  10 ,
      right: 10,
      width: '25px',
    }} />
  )
}

export default CountryFlag
